import { RobotIcon } from 'assets/icons';
import format from 'date-fns/format';
import InvoiceAttachment from 'pages/Conversations/components/ChannelMessage/MessageBubble/Attachments/Invoice';
import React from 'react';
import Tooltip from 'shared/components/Tooltip';
import { AutomationRunActionFragment, ChannelViewChannelMessageAttachmentFragment } from 'shared/types/graphql';
import styled from 'styled-components/macro';
interface IAutomationRunPaymentPromptProps {
  automationRunAction: AutomationRunActionFragment | undefined;
  setCurrentInvoiceId: (invoiceId: string) => void;
  actionIndex: number;
}

const AutomationRunPaymentPrompt = ({
  automationRunAction,
  setCurrentInvoiceId,
  actionIndex,
}: IAutomationRunPaymentPromptProps): JSX.Element => {
  const sentTime = format(new Date(automationRunAction?.createdAt), 'h:mmaaa');
  return (
    <PromptWrapper>
      <ChildAutomationStart>
        {actionIndex > 0 && (
          <AutomationSent>
            Automation Sent <SentTime>{sentTime}</SentTime>
          </AutomationSent>
        )}

        {automationRunAction?.order === 1 && actionIndex !== 0 && (
          <Tooltip content={automationRunAction.automationAction?.workflowEventSetting?.name}>
            <RobotIcon />
          </Tooltip>
        )}
      </ChildAutomationStart>
      <Question>{automationRunAction?.body}</Question>
      <Answer>
        <InvoiceAttachment
          attachment={automationRunAction?.attachments.find(
            (attachment: ChannelViewChannelMessageAttachmentFragment) => !!attachment,
          )}
          channelId={automationRunAction?.automationRun?.channelMessage?.channel?.id || ''}
          setCurrentInvoiceId={setCurrentInvoiceId}
        />
      </Answer>
    </PromptWrapper>
  );
};

export default AutomationRunPaymentPrompt;

const Question = styled.div`
  margin: 4px 0 22px 0;
  white-space: pre-wrap;
`;

const Answer = styled.div`
  background-color: var(--chakra-colors-background-primaryAlpha-hover);
  border-left: 4px solid var(--chakra-colors-border-brand);
  padding: 12px;
  margin-top: 24px;
`;

const ChildAutomationStart = styled.div`
  display: flex;
  margin-top: 14px;
  align-items: center;
`;

const AutomationSent = styled.div`
  font-weight: 600;
  margin-right: 8px;
  font-size: 14px;
`;
const SentTime = styled.span`
  font-size: 12px;
  color: var(--chakra-colors-text-subtle);
  font-weight: 400;
`;

const PromptWrapper = styled.div`
  padding: 20px 24px;
`;
